import { render, staticRenderFns } from "./knowledgeCategory.vue?vue&type=template&id=284cfbbd&scoped=true"
import script from "./knowledgeCategory.vue?vue&type=script&lang=js"
export * from "./knowledgeCategory.vue?vue&type=script&lang=js"
import style0 from "./knowledgeCategory.vue?vue&type=style&index=0&id=284cfbbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284cfbbd",
  null
  
)

export default component.exports